export default "__VITE_ASSET__BxIe4Fqi__"